import Action from '../Action';
import VehicleAdService from '../../services/Vehicle/VehicleAdService';
import { message } from 'antd';

export function searchAds(type, query, user, featured) {
	return (dispatch) => {
		VehicleAdService.search(type, query, user, featured)
			.then((ads) => {
				dispatch({ type: Action.SEARCH_VEHICLE_ADS, searchedAds: ads.data });
			})
			.catch((error) => message.error('Failed to search vehicle ads!'));
	};
}

export function fetchAds(page, pageLimit, type) {
	return (dispatch) => {
		VehicleAdService.get(page, pageLimit, type)
			.then((ads) => dispatch({ type: Action.FETCH_VEHICLE_ADS, ads: ads.data.docs, pages: ads.data.pages }))
			.catch((error) => message.error('Failed to fetch vehicle ads!'));
	};
}

export function addVehicleAd(body) {
	return (dispatch) => {
		VehicleAdService.add(body)
			.then((ad) => {
				dispatch({ type: Action.POST_VEHICLE_AD, ad: ad.data });
				message.success('Ad Added');
			})
			.catch((error) => message.error('Failed to add vehicle ad!'));
	};
}

export function updateVehicleAd(id, body) {
	return (dispatch) => {
		VehicleAdService.update(id, body)
			.then((ad) => {
				dispatch({ type: Action.UPDATE_VEHICLE_AD, ad: ad.data });
				message.success('Ad Updated');
			})
			.catch((error) => message.error('Failed to update vehicle ad!'));
	};
}

export function updateFeatureStatus(id, body) {
	return (dispatch) => {
		VehicleAdService.updateFeatureStatus(id, body)
			.then((ad) => {
				dispatch({ type: Action.UPDATE_VEHICLE_FEATURE_STATUS, ad: ad.data });
				message.success('Ad Updated');
			})
			.catch((error) => message.error('Failed to update vehicle ad!'));
	};
}

export function deleteVehicleAd(id) {
	return (dispatch) => {
		VehicleAdService.delete(id)
			.then((ad) => {
				dispatch({ type: Action.DELETE_VEHICLE_AD, ad: ad.data });
				message.success('Ad Deleted');
			})
			.catch((error) => message.error('Failed to delete vehicle ad!'));
	};
}
